export function getRouteForElement(type: string, id: number): string[] | null {
  const iD = id.toString();
  switch (type) {
    case 'Budget':
      return ['main', 'budgets', iD];
    case 'CheckIn':
      return ['main', 'orders', iD];
    case 'Client':
      return ['main', 'crm', 'clients', iD];
    case 'Crm::Booking':
    case 'Crm':
      return ['main', 'crm', iD];

    case 'InventoryAction':
      return ['main', 'inventory-actions', iD];
    case 'InventoryAction::BuyOrder':
      return ['main', 'inventory-actions', iD];
    case 'InventoryAction::Consume':
      return ['main', 'inventory-actions', iD];
    case 'InventoryAction::Loss':
      return ['main', 'inventory-actions', iD];
    case 'InventoryAction::Movement':
      return ['main', 'inventory-actions', iD]; 
    case 'InventoryAction::Pricing':
      return ['main', 'inventory-actions', iD];
    case 'InventoryAction::Stock':
      return ['main', 'inventory-actions', iD];

    case 'Order':
    case 'OrderComment':
    case 'OrderNotification':
    case 'Recall':
      return ['main', 'orders', iD];
    case 'WorkInstance':
    case 'WorkAssignation':
    case 'WorkRequest':
    case 'UserAssignation':
      return ['main', 'work', iD];
    default:
      return null;
  }
}
